import React from 'react';
import axios from 'axios';
import ShoppingCarouselItem from './ShoppingCarouselItem';
import Carousel from './Carousel';

const unsafeAxios = axios.create({
    withCredentials: false
});

class ShoppingCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            items: [],
            galleryData: {}
        }

        this.brandName = this.getBrandName();
    }

    getBrandName() {
        let hostname = window.location.hostname.split('.');
        hostname.pop();
        return hostname.pop();
    }

    componentDidMount() {
        this.fetchConfig();
    }

    fetchConfig() {
        axios.get(`/api/affiliategallery/`)
            .then(
                (res) => {
                    const gallery = res.data;

                    this.setState({
                        items: gallery && gallery.products ? gallery?.products.map?.(this.mapProducts.bind(this)) : [],
                        galleryData: gallery ?? {}
                    })
                }
            );
    }

    mapProducts(product, index) {
        return (
            <ShoppingCarouselItem index={index} key={product.id} data={product} />
        )
    }


    render() {
        // Disable for these
        switch (this.brandName) {
            case 'allas':
            // case 'elle':
            // case 'femina':
            case 'hant':
            case 'mabra':
            // case 'svenskdam':
            case 'residencemagazine':
            case 'motherhood': return null;
        }
        return (
            <React.Fragment>
                <div className="shop_carousel__disclaimer shop_carousel__disclaimer--outer">{this.state.galleryData.product_module_disclaimer}</div>
                <div className="shop_carousel__title shop_carousel__title--outer" data-carousel-title={this.state.galleryData.product_module_title}>
                    {this.state.galleryData.product_module_title}
                </div>
                <div className="shop_carousel" data-cts-object-group>
                    {window.blogLogo.length > 0 &&
                        <div className="shop_carousel__logo">
                            <img src={window.blogLogo} alt="" />
                        </div>
                    }
                    <div className="shop_carousel__title shop_carousel__title--inner" data-carousel-title={this.state.galleryData.product_module_title}>
                        {this.state.galleryData.product_module_title}
                    </div>
                    <div className="shop_carousel__disclaimer shop_carousel__disclaimer--inner">
                        {this.state.galleryData.product_module_disclaimer}
                    </div>
                    <div className="shop_carousel__container cts-tracking-object"
                        data-cts-object-category="affiliate_carousel"
                        data-cts-object-name={this.state.galleryData.product_module_title}
                        data-cts-object-extra-info={JSON.stringify([{ type: 'carousel' }])}>
                        <div className="shop-car-products" id={`shop-car-products-${this.state.galleryData.id}`}>
                            <Carousel itemWidth={200}>
                                {this.state.items}
                            </Carousel>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default ShoppingCarousel;